




























































import { Component, Vue } from 'vue-property-decorator';
import StSearch from '@/components/basic/StSearch.vue';
import { DeleteResultModel, TimeEntryExtraFieldMetadataViewModel } from '@/services/api/nswag/stapiclient_generated';
import { stCustomerApi, timeEntryExtraFieldMetadataClient } from '@/services/st-api';
import { DialogResponse } from 'vue-tailwind/dist/components/TDialog';
import { notifySuccess } from '@/utlitities/notifications';

@Component({
  components: {
    StSearch,
  },
})
export default class TimeEntryExtraFieldMetadata extends Vue {
  search: string = '';
  loading: boolean = true;
  delLoading: boolean = false;
  items: TimeEntryExtraFieldMetadataViewModel[] = [];

  delayLoading=false;

  async mounted() {
    try {
      this.loading = true;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  async beforeRouteUpdate(to: any, from: any, next: any) {
    if (to.name == 'TimeEntryExtraFields') {
      try {
        this.delayLoading = true;
        await this.loadData();
      } finally {
        this.delayLoading = false;
      }
      next();
    } else {
      next();
    }
  }

  get filteredItems() {
    return this.items?.filter((x) => x.description?.toLowerCase().indexOf(this.search.toLowerCase()) != -1);
  }

  async loadData() {
    this.items = await timeEntryExtraFieldMetadataClient.getList();
  }

  edit(id: number) {
    this.$router.push({ name: 'TimeEntryExtraFieldsEdit', params: { id: id.toString() } });
  }

  async deleteExtraField(id: number) {
    try {
      this.delLoading = true;
      const result = await timeEntryExtraFieldMetadataClient.delete(id, false);
      if (result.confirmationNeeded) {

        const res: DialogResponse = await this.$dialog.confirm({
          title: this.$t('Bestätigung').toString(),
          text: result.message,
          variant: 'danger',
          okButtonText: this.$t('Löschen').toString(),
          cancelButtonText: this.$t('Abbrechen').toString()
        });

        if (res.isOk) {
          await timeEntryExtraFieldMetadataClient.delete(id, true);
          await this.loadData();
          notifySuccess('Erfolgreich gelöscht');
        }
      } else {
        await this.loadData();
        notifySuccess('Erfolgreich gelöscht');
      }
    } finally {
      this.delLoading = false;
    }
  }
}
